import { TravelAgencyAccount } from './types';
import { BillingContactPDFType } from '../../components/Pdfs/PdfComponents/PdfBillingContactDetails';

export const getPdfAgentInfo: (currSupplier: TravelAgencyAccount | undefined) => BillingContactPDFType = (
    currAgent: any
) => {
    return {
        name: currAgent?.companyName || '',
        address: currAgent?.address?.address || '',
        city: currAgent?.address?.city || '',
        country: currAgent?.address?.country?.name || '',
        postalCode: currAgent?.address?.postalCode || '',
        vatNumber: currAgent?.vatNumber || '',
        phones: currAgent?.phones || []
    };
};
